<template>
  <div class="search-banners">
     <div class="row">
        <div class="col-sm-12 search" align="center">
          <div class="row">
            <div class="col-sm-12">
              <div class="input-group flex-nowrap">
                  <input type="text" class="form-control" v-model="qSearch" :placeholder="placeholder" v-on:keyup.enter="search()" @mouseover="accebility(placeholder)" @input="searchAutocomplete()">
                  <span class="input-group-text" id="addon-wrapping" @click="search()">
                  <img v-bind:src="require('@/assets/icon/icon-search.png')">
                  </span>
              </div>
              <div class="card sugest-search" v-if="showSugest">
                  <ul>
                    <li v-for="itemSugest in listAutocomplete" :key="itemSugest" @click="toPagesautocomplate(itemSugest)">{{ itemSugest }}</li>
                    <li style="color: #0000007b;" v-if="listAutocomplete.length == 0">Tidak ada data ditemukan</li>
                  </ul>
              </div>
            </div>
            <div class="col-sm-12 menu">
              <ul>
                <li @click="search('all')">Semua</li>
                <li @click="search('artikel')">Artikel</li>
                <li @click="search('analisis')">Analisis</li>
                <li @click="search('produk-statistik')">Produk Statistik</li>
                <li @click="search('infografis')">Infografis</li>
              </ul>
            </div>
          </div>
        </div>
     </div>
  </div>
</template>
<script>
  import axios from 'axios';
  export default {
    name: 'BannerComponents',
    components: {},
    data() {
      return {
        baseApi:this.$store.state.apiUrl,
        qSearch: '',
        menuPage: [],
        selectedPage: '',
        isAccebility:this.$store.state.isAccebility,
        listAutocomplete:[],
        showSugest:false
      }
    },
    mounted() {

    },
    methods: {
      search(category) {
        if(category){
          window.location.href = "search?q=" + this.qSearch + "&halaman=statistik-sektoral&kategori="+category+"&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        } else {
          window.location.href = "search?q=" + this.qSearch + "&halaman=statistik-sektoral&kategori=all&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
        }
      },
      toPagesautocomplate(){
        window.location.href = "search?q=" + this.qSearch + "&halaman=statistik-sektoral&kategori=all&topik=all&organisasi=all&status=all&sort=desc&page_no=1&show_filter=true&lang=id"
      },
      accebility(voice){
        if(this.isAccebility.modeSuara){
          let msg = new SpeechSynthesisUtterance();
          let voices = window.speechSynthesis.getVoices()
          msg.voice = voices[160];
          msg.text = voice;
          msg.volume = 10;
          msg.rate = 1;
          msg.pitch = 1;
          window.speechSynthesis.cancel();
          window.speechSynthesis.speak(msg);
        }
      },
      searchAutocomplete(){
        if(this.qSearch.length > 1 ){
          this.showSugest = true
          let params = {
            qSearch: this.qSearch
          }
          axios.post(`${this.baseApi}/api/v2/satudata/searchautocomplete`, params).then(res=>{
            let dataSearch = []
            if(res.data.length > 0){
              for(let i = 0; i<5; i++){
                if(res.data[i]){
                  dataSearch.push(res.data[i].title)
                }
              }
            }
            this.listAutocomplete = dataSearch
          })
        } else if(this.qSearch.length < 2){
          this.showSugest = false
          this.listAutocomplete = []
        }
      }
    }
  }
</script>